import {
  ADD_TO_BOOKMARK,
  FETCH_BOOKMARKS_REQUEST,
  FETCH_BOOKMARKS_SUCCESS,
  FETCH_BOOKMARKS_FAILURE,
  ADD_BOOKMARK_REQUEST,
  ADD_BOOKMARK_SUCCESS,
  ADD_BOOKMARK_FAILURE,
  DELETE_BOOKMARK_REQUEST,
  DELETE_BOOKMARK_SUCCESS,
  DELETE_BOOKMARK_FAILURE,
  CLEAR_BOOKMARKS,
} from "../types/bookmarkTypes";

const initialState = {
  bookmarkItems: [],
  fetched: false, // Track if bookmarks have been fetched from API
  pagination: {},
};

// Transform API response to match the expected product structure
const transformApiBookmark = (apiBookmark) => {
  const fabricData = apiBookmark.attributes.fabric?.data;
  const knitData = apiBookmark.attributes.knit?.data;
  const stockData = apiBookmark.attributes.stock?.data;
  const productData = fabricData || knitData || stockData;

  if (!productData) return null;

  return {
    id: productData.id,
    bookmarkId: apiBookmark.id, // Store the bookmark ID for potential future deletion
    // Which collection this bookmark came from, so links to the product page can
    // say so instead of relying on the mode the user happens to be browsing in
    itemType: fabricData ? "fabric" : knitData ? "knit" : "stock",
    attributes: {
      ...productData.attributes,
      // Map additional fields that may come from the API
      primary_image: productData.attributes.primary_image,
      image: productData.attributes.image,
      width: productData.attributes.width,
    },
  };
};

const bookmarkReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch bookmarks from API
    case FETCH_BOOKMARKS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_BOOKMARKS_SUCCESS:
      // Transform API response to match expected structure
      const transformedBookmarks = action.payload.data
        .map(transformApiBookmark)
        .filter(Boolean); // Remove null values

      return {
        ...state,
        loading: false,
        bookmarkItems: transformedBookmarks,
        pagination: action.payload.meta.pagination,
        fetched: true,
        error: null,
      };

    case FETCH_BOOKMARKS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        fetched: true,
      };

    // Add bookmark via API
    case ADD_BOOKMARK_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ADD_BOOKMARK_SUCCESS:
      const { bookmarkId, product, itemType } = action.payload;
      const existingItem = state.bookmarkItems.find(
        (item) => item.id === product.id
      );

      if (existingItem) {
        return {
          ...state,
          loading: false,
        };
      }

      return {
        ...state,
        loading: false,
        bookmarkItems: [
          ...state.bookmarkItems,
          {
            ...product,
            bookmarkId: bookmarkId,
            itemType: itemType || "fabric",
          },
        ],
      };

    case ADD_BOOKMARK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_BOOKMARK_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DELETE_BOOKMARK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case DELETE_BOOKMARK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Legacy local add (kept for backward compatibility)
    case ADD_TO_BOOKMARK:
      const existingBookmarkItem = state.bookmarkItems.find(
        (item) => item.id === action.payload.id
      );

      if (existingBookmarkItem) {
        return state; // Item already bookmarked
      }

      return {
        ...state,
        bookmarkItems: [...state.bookmarkItems, action.payload],
      };

    case CLEAR_BOOKMARKS:
      return initialState;

    default:
      return state;
  }
};

export default bookmarkReducer;
